<template>
  <div class="timetable" v-if="!isLoading">
    <template v-if="epgList.length">
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(epg, index) in epgList" :key="index">
          <div class="time-wrap">
            <div class="time-text">
              <span class="epg-title-line1">{{ epg.title }}</span>
              <span class="epg-title-line2">{{ formatEpgsTime(epg.starttime) }} - {{ formatEpgsTime(epg.endtime) }}</span>
            </div>
            <div v-if="buttonClass(epg)" :class="buttonClass(epg)">
              <a v-if="buttonClass(epg) !== 'time-alarm'"
                 @click.prevent="clickEpgsBtn(epg)" href="#">{{ buttonText(epg)}}</a>
              <btn-live-alarm
                v-if="buttonClass(epg) === 'time-alarm' && !isPooqzone"
                :isOn="epg.alarm" :targetDate="epg.starttime" :contentsId="epg.channelid"
                :programId="epg.programid" :index="index"/>
            </div>
          </div>
          <div v-if="buttonClass(epg) === 'live-schedule-button-blue'"
               class="time-progress">
            <span :style="'width:' + progress(epg) + '%;'"></span>
          </div>
        </swiper-slide>
      </swiper>
      <div :id="'swiper-button-prev-program'" class="swiper-button-prev"></div>
      <div :id="'swiper-button-next-program'" class="swiper-button-next"></div>
      <!-- 편성표 리스트 -->
    </template>
    <div v-else class="live-epg-empty">
      <img src="../../assets/images/common/icon-error-74.png" alt="">
      <p class="list-empty-text">방송정보가 없어요.</p>
    </div>
  </div>

</template>
<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { getLiveEpgsChannelsDetail, getVodProgramsContentid } from '@/common/utils/request'
  import BtnLiveAlarm from '@/components/button/BtnLiveAlarm'
  import cookie from '@/common/utils/cookie'
  import shave from '@/common/utils/customShave'
  import _ from 'lodash'
  import { PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'
  const EPG_TYPE = {
    PAST: 'past',
    FUTURE: 'future',
    PRESENT: 'present'
  }

  export default {
    name: 'EpgSlider',
    props: {
      channelId: {
        type: String
      },
      isHomeShopping: {
        type: Boolean
      },
      dataHomeShopping: {
        type: Object
      },
      dataHomeShoppingAddInfo: {
        type: Object
      }
    },
    data () {
      return {
        isPooqzone: cookie.isWavveOn(),
        epgTimer: null,
        epgTimerSeconds: 60 * 1000 * 5,
        epgList: [],
        isLoading: true,
        swiperOptions: {
          paginationClickable: true,
          slidesPerView: 4,
          slidesPerGroup: 1,
          pagination: '.swiper-pagination',
          nextButton: '#swiper-button-next-program',
          prevButton: '#swiper-button-prev-program'
        }
      }
    },
    components: {
      swiper,
      swiperSlide,
      BtnLiveAlarm
    },
    methods: {
       setEpgListData () {
        this.isLoading = true
        this.fetchEpgList().then(() => {
          this.isLoading = false
          this.$nextTick(() => {
            this.shaveText()
          })
        })
       },
      fetchEpgList () {
        let startDateTime = new Date()
        let endDateTime = new Date()
        endDateTime.setDate(endDateTime.getDate() + 1)
        // this.epgList = []
        return getLiveEpgsChannelsDetail({
          channelid: this.channelId,
          startdatetime: this.dateFormat(startDateTime),
          enddatetime: this.dateFormat(endDateTime),
          offset: 0,
          limit: 100,
          orderby: 'old' })
          .then(({ data }) => {
            this.epgList = _.get(data, 'list', [])
          })
      },
      shaveText () {
        this.$nextTick(() => {
          shave('.epg-title-line1', 27)
        })
      },
      buttonClass (data) {
        let epgType = this.getEpgType(data)

        if (epgType === EPG_TYPE.PAST) {
          if (data.programid) {
            return 'live-schedule-button-gray'
          }
          return ''
        } else if (epgType === EPG_TYPE.PRESENT) {
          return 'live-schedule-button-blue'
        }
        return 'time-alarm'
      },
      formatEpgsTime (sTime) {
        return sTime.substring(sTime.length - 5, sTime.length)
      },
      clickEpgsBtn (epgData) {
        const epgType = this.getEpgType(epgData)

        if (epgType === EPG_TYPE.PAST) {
          getVodProgramsContentid({ programid: epgData.programid }).then(({ data }) => {
            const postfix = data.contentid ? '&contentid=' + data.contentid : ''
            this.$router.push({
              name: PATH_NAME_PLAYER_VOD,
              query: {
                programid: epgData.programid + postfix,
                contentid: data.contentid
              }
            })
          })
        } else if (this.isHomeShopping && _.get(this.dataHomeShopping, 'orderurl', '') !== '') {
          window.open('http://' + this.dataHomeShopping.orderurl, '_blank')
        }
      },
      getStartEndTimeCurrentTime (epgData) {
        const tempSt = epgData.starttime.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
        const tempEt = epgData.endtime.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
        const currentTime = new Date() / (1000 * 60)
        const startTime = new Date(tempSt[1], tempSt[2] - 1,
          tempSt[3], tempSt[4], tempSt[5]).getTime() / (1000 * 60)
        const endTime = new Date(tempEt[1], tempEt[2] - 1,
          tempEt[3], tempEt[4], tempEt[5]).getTime() / (1000 * 60)
        return { currentTime, startTime, endTime }
      },
      getEpgType (epgData) {
        const { startTime, endTime, currentTime } = this.getStartEndTimeCurrentTime(epgData)
        if (currentTime > new Date(endTime)) {
          return EPG_TYPE.PAST // 과거
        } else if (currentTime < new Date(startTime)) {
          return EPG_TYPE.FUTURE // 미래
        }
        return EPG_TYPE.PRESENT // 현재
      },
      progress (epgData) {
        const { startTime, endTime, currentTime } = this.getStartEndTimeCurrentTime(epgData)
        const totalTime = endTime - startTime
        const time = currentTime - startTime
        return Math.min(100, (time / totalTime) * 100)
      },
      pad (num, width) {
        const numStr = num + ''
        return numStr.length >= width ? numStr
          : new Array((width - numStr.length) + 1).join('0') + numStr
      },
      dateFormat (date) {
        return date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' +
          this.pad(date.getDate(), 2) + ' ' + this.pad(date.getHours(), 2) + ':' +
          this.pad(date.getMinutes(), 2)
      },
      buttonText (data) {
        const epgType = this.getEpgType(data)
        if (epgType === EPG_TYPE.PAST) {
          return '다시보기'
        } else if (epgType === EPG_TYPE.PRESENT) {
          let isPreOrder = this.isHomeShopping && _.get(this.dataHomeShopping, 'orderurl', '') !== ''
          return isPreOrder ? '바로주문' : '방송중'
        }
        return ''
      }
    },
    created () {
      this.setEpgListData()
    },
    mounted () {
      this.epgTimer = setInterval(() => {
         this.fetchEpgList().then(() => {
           this.$nextTick(() => {
             this.shaveText()
           })
         })
      }, this.epgTimerSeconds)
    },
    beforeDestroy () {
      clearInterval(this.epgTimer)
    }
  }
</script>
